import { StrictMode, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@avayler/saas-nextjs-auth-cognito-client';

// import i18n (needs to be bundled ;))
import './i18n.ts';
import './utils/zodDefaultMessages.ts';

import LandingPage from './components/landing-page/LandingPage.tsx';
import { BoundaryError } from './pages/error/BoundaryError.tsx';
import { AppProvider } from './providers/AppProvider.tsx';
import { clientConfig } from './clientConfig.ts';
import { router } from './router.tsx';

import './index.css';
import 'antd/dist/reset.css';

const getLoginState = async () =>
  await AuthProvider.hasAuthToken(clientConfig.bffBaseUrl);

export const App = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);

  useEffect(() => {
    getLoginState().then((isAuthenticated) => {
      setAuthenticated(isAuthenticated);
      setIsAuthenticating(false);
    });
  }, []);

  if (!authenticated) {
    return <LandingPage loading={isAuthenticating} />;
  }

  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <ErrorBoundary fallbackRender={() => <BoundaryError />}>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
